// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"e0c05130","323":"ff646849","414":"75b6ecdf","427":"44559495","453":"12cf2e65","531":"4bd3f8d2","912":"74a9ebe5","916":"a4fb4ed2"}[chunkId] + ".chunk.js";
};